import React from 'react';
import { Card, CardHeader } from '@progress/kendo-react-layout';

interface DashboardPanelProps {
  /** Toolbar / filter content rendered in the bordered panel header. Omit for a header-less panel. */
  toolbar?: React.ReactNode;
  /** Panel body — fills the remaining height. The caller owns scrolling/padding on its own content. */
  children: React.ReactNode;
  /** Extra classes for the outer Kendo Card. */
  className?: string;
}

/**
 * Standard dashboard panel shell: a full-height white Kendo `Card` with an optional bordered
 * header (toolbar/filters) above a flexible body. Replaces the repeated
 * `m-2 … rounded-lg border … bg-white shadow-sm` markup used across the dashboard tabs
 * (Overview, Notes, Site Workbook, Analysis).
 *
 * Mobile-friendly: the header is allowed to wrap; the caller's toolbar content is responsible
 * for its own responsive control widths (e.g. full-width search on small screens).
 */
export default function DashboardPanel({ toolbar, children, className }: DashboardPanelProps) {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <Card
        className={`m-2 flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${className ?? ''}`}
      >
        {toolbar !== undefined && (
          <CardHeader className="shrink-0 !rounded-none !border-0 !border-b !border-gray-200 !bg-transparent !px-4 !py-3">
            {toolbar}
          </CardHeader>
        )}
        {children}
      </Card>
    </div>
  );
}
